<template>
  <div>
    <pre>{{ list }}</pre>
    <div>L'id du dernier est : {{ lastId() }}</div>
  </div>
</template>

<script>
import {User} from "@/js/caller";

export default {
  name: "MailListVue",
  data() {
    return {
      min   : this.$route.query.from || 0,
      eleves: [],
      list  : ''
    }
  },
  methods: {
    buildList() {
      const {eleves, min} = this;
      console.log(this.$route.query);
      return eleves.filter(e => e.order > min).map(e => e.mail).join(",\n");
    },
    lastId() {
      return this.eleves.filter(e => e.order > this.min).slice(-1)[0]?.order
    }
  },
  created() {
    User.GetUsers().then(res => {
      this.eleves = res;
      this.list = this.buildList()
    })
  }
}
</script>

<style scoped>

</style>